<template>
  <v-row>
    <v-col class="pb-0 pt-0" cols="12" md="12" lg="12">
      <el-button
        small
        v-if="!onlyView"
        class="mb-3"
        color="primary"
        icon="ieškoti"
        title="Ieškoti"
        :loading="loading"
        @click.native.stop="newProvider()"
      />
    </v-col>
    <template v-if="showProviderDataJur">
      <v-col class="pb-0" cols="12" md="6" lg="3">
        <el-textarea
          label="JA kodas"
          disabled
          v-model="formData.data_provider.code"
        />
      </v-col>
      <v-col class="pb-0" cols="12" md="6" lg="3">
        <el-textarea
          label="JA pavadinimas"
          disabled
          v-model="formData.data_provider.fullname"
        />
      </v-col>
      <v-col class="pb-0" cols="12" md="6">
        <el-textarea
          label="Adresas"
          disabled
          v-model="formData.data_provider.adr_text"
        />
      </v-col>
      <v-col class="pb-0" cols="12" md="6">
        <el-textarea
          :disabled="onlyView"
          label="Kita informacija"
          v-model="formData.data_provider_other_info"
          :maxlength="2000"
        />
      </v-col>
    </template>
    <template v-if="showProviderDataFiz">
      <v-col class="pb-0" cols="12" md="6" lg="3">
        <el-textarea
          label="Vardas"
          disabled
          v-model="formData.data_provider.name"
        />
      </v-col>
      <v-col class="pb-0" cols="12" md="6" lg="3">
        <el-textarea
          label="Pavardė"
          disabled
          v-model="formData.data_provider.lastname"
        />
      </v-col>
      <v-col class="pb-0" cols="12" md="6" lg="3">
        <el-textarea
          label="Asmens kodas / ILTU kodas / Gimimo data"
          disabled
          v-model="formData.data_provider.code"
        />
      </v-col>
      <v-col class="pb-0" cols="12" md="6">
        <el-textarea
          :disabled="onlyView"
          label="Kita informacija"
          v-model="formData.data_provider_other_info"
          :maxlength="2000"
        />
      </v-col>
    </template>
    <!-- modal  -->
    <modal-add-person
      v-if="showAddProvider"
      v-model="showAddProvider"
      :modalType="modalType"
      :hideIndividual="addPersonShowSelect"
      :additionalData="[formData.data_provider]"
      @addPersonData="addProvider"
    />
  </v-row>
</template>

<script>
import ModalAddPerson from '@/components/modals/ModalAddPerson'

export default {
  name: 'RequestDataProvider',
  components: {
    ModalAddPerson,
  },
  props: {
    formData: [Array, Object],
    onlyView: Boolean,
  },
  data() {
    return {
      loading: false,
      showAddProvider: false,
      Provider: {},
      ProvidersList: [],
      modalType: null,
    }
  },
  computed: {
    addPersonShowSelect() {
      return this.formData?.in_journal_type == '421'
    },
    showProviderDataJur() {
      return this.formData?.data_provider?.type == 'JUR'
    },
    showProviderDataFiz() {
      return this.formData?.data_provider?.type == 'FIZ'
    },
  },
  methods: {
    newProvider() {
      this.modalType = 'data_provider'
      this.showAddProvider = true
    },
    addProvider(item) {
      this.$set(this.formData, 'data_provider_amn_id', item.amn_id)
      this.$set(this.formData, 'data_provider', {})
      this.$set(this.formData.data_provider, 'code', item.code || "")
      this.$set(this.formData.data_provider, 'name', item.name || "")
      this.$set(this.formData.data_provider, 'lastname', item.lastname || "")
      this.$set(this.formData.data_provider, 'fullname', item.fullname || "")
      this.$set(this.formData.data_provider, 'adr_text', item.adr_text || "")
      this.$set(this.formData.data_provider, 'country', item.country || "")
      this.$set(this.formData.data_provider, 'amn_id', item.amn_id || "")
      this.$set(this.formData.data_provider, 'type', item.type || "")

      this.showAddProvider = false
    },
  },
}
</script>

<style>
</style>
